import { gql, type LazyQueryHookOptions, type QueryHookOptions, useLazyQuery, useQuery } from '@apollo/client';
import { jsonToGraphQLQuery } from 'json-to-graphql-query';
import { CollectionSimple } from 'src/dynamoQueries/collections';

interface CollectionQueryOptions {
  variables?: Record<string, unknown>;
  options?: QueryHookOptions | LazyQueryHookOptions;
  shared?: boolean;
  lazy?: boolean;
}

const buildCollectionQuery = (shared: boolean) => {
  const query = CollectionSimple(true, shared);
  return gql(jsonToGraphQLQuery(query, { pretty: true }));
};

export const useCollectionSimpleQuery = ({
  variables,
  options,
  shared = false,
  lazy = false,
}: CollectionQueryOptions) => {
  // If lazy is true, use lazy query instead
  const lazyResult = useLazyQuery(buildCollectionQuery(shared), {
    variables,
    ...options,
  });

  const normalResult = useQuery(buildCollectionQuery(shared), {
    variables,
    skip: lazy, // Skip normal query if lazy mode
    ...options,
  });

  return lazy ? lazyResult : normalResult;
};

export const useCollectionSimpleLazyQuery = ({ variables, options, shared = false }: CollectionQueryOptions) => {
  return useLazyQuery(buildCollectionQuery(shared), {
    variables,
    ...options,
  });
};
